import { useEffect, useState } from "react";
import { IGif, INiche } from "services/types";
import { apiMain, apiNiches } from "services";
import { useSelector } from "react-redux";
import { IAppState } from "store/app-state";

export enum Roles {
  admin="admin",
  moderator="moderator",
  owner="owner",
}

interface IProps {
  gifId: string;
  role: Roles;
}

interface IReturn {
  gif?: IGif;
  niches?: INiche[];
  isLoading: boolean;
  isError: boolean;
}

export const useData = ({ gifId, role }: IProps): IReturn => {
  const myNiches = useSelector((state: IAppState) => state.user.myNiches);
  const [gif, setGif] = useState<IGif>();
  const [niches, setNiches] = useState<INiche[]>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await apiMain.fetchGifById(gifId);
        setGif(response.gif);

        if (role === Roles.owner) {
          setNiches(response.niches);
        }

        if (role === Roles.admin) {
          const response = await apiNiches.getNiches({
            order: "name",
            previews: false,
          });
          setNiches(response.niches);
        }

        if (role === Roles.moderator) {
          setNiches(myNiches);
        }
      } catch (e) {
        console.error(`Could not get gif niches or niches list: ${e}`);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [gifId, role, myNiches]);

  return {
    gif,
    niches,
    isLoading,
    isError,
  };
};
